import React from "react";
import aiAnalysisCardIcon from "assets/ai_driven.svg";
import CONSTANTS from "constants/constants";

const { MARKET_PULSE } = CONSTANTS;

const AiAnalysisCard = () => (
  <div className="ai-analysis-card-flex pt2">
    <div className="ai-analysis-card-content">
      <div className="ai-analysis-card-title">
        <span className="ai-analysis-card-title-highlight">{MARKET_PULSE.AI_TITLE_HIGHLIGHT}</span> {MARKET_PULSE.AI_TITLE}
      </div>
      <ul className="ai-analysis-card-list pt2">
        <li>
          <span className="dashboard-card-dot" />
          <span className="ai-analysis-card-list-title">{MARKET_PULSE.AI_LIST_1_TITLE}</span>
        </li>
        <li>
          <div className="ai-analysis-card-list-desc">{MARKET_PULSE.AI_LIST_1_DESC}</div>
        </li>
        <li>
          <span className="dashboard-card-dot" />
          <span className="ai-analysis-card-list-title">{MARKET_PULSE.AI_LIST_2_TITLE}</span>
        </li>
        <li>
          <div className="ai-analysis-card-list-desc">{MARKET_PULSE.AI_LIST_2_DESC}</div>
        </li>
      </ul>
    </div>
    <div className="ai-analysis-card-graphic">
      <img src={aiAnalysisCardIcon} alt="AI Analysis Card" />
    </div>
  </div>
);

export default AiAnalysisCard; 